import React, { useRef } from "react";

const PaidUser = props => {
  const {
    analyRadius,
    analyBHHeight,
    analyPump,
    analyWL,
    meshRadius,
    meshZSplit,
    meshSplit,
    meshBias,
    modelKind,
    analyType,
    wldAmount,
    pompAmount,
    wsAr,
    mapMeshLay,
    screenZSplit,
    waterShedSelectable,
    regionModelWindowVisible,
    lakeTrData,
    initTemp,
    considerMat,
    equPermCheck,
    probThreshold,
    meshVertex,
    autoScrChk,
    changeIdoPram,
    checkModelKind,
    checkIdoPram,
    changeVisible,
    getTargetBor,
    checkTarget,
    deleteSelectedWaterShed,
    changeField,
    doExe,
    closeSw,
  } = props;
  const tbRef = useRef(null);
  return (
    <div>
      {modelKind != 3 && (
        <fieldset className="Unit l-mtS">
          <legend> 1.&nbsp;原位置条件</legend>
          <div>
            <fieldset className="Unit l-mtSSS">
              <legend> 井戸座標</legend>
              <div>
                <label className="wl_label">緯度(度)：</label>
                <input className="textSSA" id="Lat" type="text" disabled="disabled" value={window.getCP()[1].toFixed(5)} />
                <label className="wl_label">経度(度)：</label>
                <input className="textSSA" id="Lon" type="text" disabled="disabled" value={window.getCP()[0].toFixed(5)} />
              </div>
            </fieldset>

            <fieldset className="Unit l-mtSSS">
              <legend>
                {" "}
                <input type="checkbox" id="idoCheck" name="1" className="check" onChange={e => changeVisible(e, "idoSize")} />
                <label htmlFor="idoCheck"></label>
                &nbsp;井戸寸法
              </legend>
              <div id="idoSize" className="optCheck">
                <div>
                  <label className="wl_label">半径(m)：</label>
                  <input className="textSSR" type="text" value={analyRadius} onChange={e => changeIdoPram(e, "ar")} onBlur={e => checkIdoPram(e, "ar")} />
                  <label className="wl_label">下端深度(m)：</label>
                  <input className="textSSR" type="text" value={analyBHHeight} onChange={e => changeIdoPram(e, "ah")} onBlur={e => checkIdoPram(e, "ah")} />
                </div>
                <div>
                  <label className="wl_label">ポンプ位置深度(m)：</label>
                  <input className="textSSR" type="text" value={analyPump} onChange={e => changeIdoPram(e, "ap")} onBlur={e => checkIdoPram(e, "ap")} />
                  <label className="wl_label">初期水位深度(m)：</label>
                  <input className="textSSR" type="text" value={analyWL} onChange={e => changeIdoPram(e, "aw")} onBlur={e => checkIdoPram(e, "aw")} />
                </div>
              </div>
            </fieldset>
          </div>
        </fieldset>
      )}

      <fieldset className="Unit l-mtSSS">
        <legend> 2.&nbsp;モデル条件</legend>
        <fieldset className="Unit l-mtSSS">
          <legend> 解析モデル</legend>
          <label className="ido_radioM">
            <input type="radio" id="circle" name="1" className="radio" onChange={e => changeIdoPram(1, "mt")} checked={checkModelKind(1)} />
            <label htmlFor="circle"></label>
            影響圏半径モデル
          </label>
        </fieldset>
        <fieldset className="Unit l-mtS">
          <legend> モデル情報</legend>
          <div>
            <label className="wl_label" id="modelInputLabel">
              モデル半径(m)：
            </label>
            <input className="textSSR" type="text" value={meshRadius} onChange={e => changeIdoPram(e, "mr")} onBlur={e => checkIdoPram(e, "mr")} />
            <label className="wl_label">鉛直方向分割数：</label>
            <input className="textSSR" type="text" value={meshZSplit} onChange={e => changeIdoPram(e, "msz")} onBlur={e => checkIdoPram(e, "msz")} />
          </div>
          <div id="modelKind" className="optBlock">
            <div>
              <label className="wl_label">半径方向分割数：</label>
              <input className="textSSR" type="text" value={meshSplit} onChange={e => changeIdoPram(e, "ms")} onBlur={e => checkIdoPram(e, "ms")} />
              <label className="wl_label">半径方向バイアス：</label>
              <input className="textSSR" type="text" value={meshBias} onChange={e => changeIdoPram(e, "mb")} onBlur={e => checkIdoPram(e, "mb")} />
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}>
              <label className="wl_label">周方向分割数：</label>
              <input className="textSSR" type="text" value={meshVertex} onChange={e => changeIdoPram(e, "mv")} onBlur={e => checkIdoPram(e, "mv")} />
              {modelKind === 3 && (
                <div>
                  <label className="wl_label">井戸半径(m)：</label>
                  <input className="textSSR" type="text" value={wsAr} onChange={e => changeIdoPram(e, "wsAr")} onBlur={e => checkIdoPram(e, "wsAr")} />
                </div>
              )}
            </div>
            <div className="optCheck">
              <label className="wl_label">マップドメッシュ化層番号：</label>
              <input className="textSSR" type="text" value={mapMeshLay} onChange={e => changeIdoPram(e, "mml")} onBlur={e => checkIdoPram(e, "mml")} />
              <label className="wl_label">スクリーン補正鉛直分割数：</label>
              <input className="textSSR" type="text" value={screenZSplit} onChange={e => changeIdoPram(e, "szs")} onBlur={e => checkIdoPram(e, "szs")} />
            </div>
          </div>
          {modelKind == 3 && (
            <div className="l-right l-mtS ">
              <legend className="ws_Check">
                <input type="checkbox" id="selWaterShedCheck" name="1" className="check" onChange={e => changeIdoPram(1, "ws")} checked={!!waterShedSelectable} />
                <label htmlFor="selWaterShedCheck"></label>
                &nbsp;流域界選択
              </legend>
              <legend className="ws_Check">
                <input type="checkbox" id="selWellsCheck" name="1" className="check" onChange={e => changeIdoPram(1, "wells")} checked={!!regionModelWindowVisible} />
                <label htmlFor="selWellsCheck"></label>
                &nbsp;複数井戸
              </legend>
            </div>
          )}
          {waterShedSelectable && (
            <div className="l-right l-mtS ">
              <button className="sBtn" onClick={deleteSelectedWaterShed}>
                流域界選択初期化
              </button>
            </div>
          )}
        </fieldset>
      </fieldset>

      <fieldset className="Unit l-mtSSS">
        <legend> 3.&nbsp;解析条件</legend>
        {modelKind == 1 && (
          <div className="">
            <label htmlFor="autoScrChk"></label>
            解析種別：
            <select className="selectM" value={analyType} onChange={e => changeIdoPram(e, "alt")}>
              <option value="2">揚水試験解析</option>
              <option value="6">井戸理論計算(Theis式)</option>
            </select>
          </div>
        )}
        {(analyType == 5 || analyType == 6) && (
          <div className="">
            <label className="kc_label">最適化計算対象ボーリング</label>
            <input className="textSSAL" id="targetKbor" type="text" disabled="disabled" value={getTargetBor} />
          </div>
        )}
        {analyType == 4 && (
          <div className="kc_label">
            <label className="kc_label">地盤初期温度(℃)：</label>
            <input className="textSSR" type="text" value={initTemp} onChange={e => changeIdoPram(e, "initTemp")} onBlur={e => checkIdoPram(e, "initTemp")} />
          </div>
        )}

        {analyType != 5 && analyType != 6 && (
          <fieldset className="Unit l-mtSSS">
            <legend> 目標量</legend>
            <div>
              <label className="ido_radioM">
                <input type="radio" id="wld" name="2" className="radio" onChange={e => changeIdoPram(1, "at")} checked={checkTarget(1)} />
                <label htmlFor="wld"></label>
                水位低下量(m)：
              </label>
              <input className="textSSR" type="text" id="inputWLD" value={wldAmount} onChange={e => changeIdoPram(e, "tw")} onBlur={e => checkIdoPram(e, "tw")} />
              <label className="ido_radioM">
                <input type="radio" id="pomp" name="2" className="radio" onChange={e => changeIdoPram(0, "at")} checked={checkTarget(0)} />
                <label htmlFor="pomp"></label>
                揚水量(m<sup>3</sup>/d)：
              </label>
              <input className="textSSR" type="text" id="inputPomp" value={pompAmount} onChange={e => changeIdoPram(e, "tp")} onBlur={e => checkIdoPram(e, "tp")} />
            </div>
          </fieldset>
        )}
      </fieldset>

      <div className="l-right l-mtS ">
        <button className="cBtn" onClick={doExe}>
          連動
        </button>
        <button className="cBtn" onClick={closeSw}>
          閉じる
        </button>
      </div>
    </div>
  );
};

export default PaidUser;
